var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIotWeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.203,
    height: 24.645,
    viewBox: "0 0 28.203 24.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.98,20.793q-2.1-8.26-4.311-16.493a1.035,1.035,0,0,0-.978-.772c-.633-.013-3.361-.009-6.518,0A3.386,3.386,0,0,0,365.4.918h0a3.39,3.39,0,1,0-5.532,2.628c-2.82.012-5.4.025-6.626.031a.974.974,0,0,0-.934.722l-4.465,16.644a.97.97,0,0,0,.935,1.227c4.467,0,19.591.006,26.135,0a1.1,1.1,0,0,0,1.065-1.373ZM362.013-.71h0A1.629,1.629,0,0,1,363.64.918h0A1.628,1.628,0,1,1,362.013-.71Z",
    transform: "translate(-347.811 2.473)",
    fill: "#7b7b7b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotWeight);
export default __webpack_public_path__ + "static/media/iotWeight.dea5211b98817c0b648853e64ca78441.svg";
export { ForwardRef as ReactComponent };